import { Navigate, useParams } from 'react-router-dom';
import { isReservedStoreSlug } from '../config/reservedSlugs.js';
import { StoreAgeRestrictionPage } from './StoreAgeRestrictionPage.jsx';
import { StorePage } from './StorePage.jsx';

/** Loja pública em `/:slug` (ex.: `/lojateste`). Rotas fixas ficam antes no router. */
export function PublicShopRoute() {
  const { slug } = useParams();

  if (isReservedStoreSlug(slug || '')) {
    return <Navigate to="/" replace />;
  }

  return <StorePage />;
}

/** Aviso de idade (menor de idade) — `/:slug/acesso-idade`. */
export function PublicAgeRestrictionRoute() {
  const { slug } = useParams();

  if (isReservedStoreSlug(slug || '')) {
    return <Navigate to="/" replace />;
  }

  return <StoreAgeRestrictionPage />;
}
